export const setShadowRootStyle = (element, selectors, styleProperty, styleValue, important) => element?.shadowRoot
    ?.querySelector(selectors)
    ?.style?.setProperty(styleProperty, styleValue, important ? 'important' : undefined);
